import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import authService from "@/services/auth";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'home',
    redirect: '/general',
    beforeEnter: authGuard,
    component: () => import('../views/HomeView.vue'),
    children: [
      {
        path: 'general',
        name: 'general',
        component: () => import('../views/GeneralView.vue'),
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('../views/UsersView.vue')
      },
      {
        path: 'suppliers',
        name: 'suppliers',
        component: () => import('../views/SuppliersView.vue')
      },
      {
        path: 'customer',
        name: 'customer',
        component: () => import('../views/CustomerInformation.vue'),
      },
      {
        path: 'productSpecificRule',
        name: 'productSpecificRule',
        component: () => import('../views/ProductSpecificRuleView.vue')
      },
      {
        path: 'item',
        name: 'item',
        component: () => import('../views/ItemView.vue'),
      },
      {
        path: 'supplierDeclarations',
        name: 'supplierDeclarations',
        component: () => import('../views/MaterialDeclarationsView.vue'),
      },
      {
        path: 'HSCode',
        name: 'HSCode',
        component: () => import('../views/HSCodeView.vue'),
      },
      {
        path: 'originDetermination',
        name: 'originDetermination',
        component: () => import('../views/OriginDeterminationView.vue'),
      },
      // {
      //   path: 'originDeterminationResult',
      //   name: 'originDeterminationResult',
      //   component: () => import('../views/OriginDeterminationResultView.vue'),
      // },
      {
        path: 'FTABillOfMaterials',
        name: 'FTABillOfMaterials',
        component: () => import('../views/FtaBOMView.vue'),
      },
      {
        path: 'dataCenter',
        name: 'dataCenter',
        component: () => import('../views/DataCenterView.vue'),
      },
      {
        path: 'certificateOfOrigin',
        name: 'certificateOfOrigin',
        component: () => import('../views/CertificateOfOriginView.vue'),
      },
      {
        path: 'purchase',
        name: 'purchase',
        component: () => import('../views/PurchaseView.vue'),
      },
      {
        path: 'sale',
        name: 'sale',
        component: () => import('../views/SaleView.vue'),
      },
      {
        path: 'bom',
        name: 'bom',
        component: () => import('../views/BOMView.vue'),
      },
      {
        path: 'subassemblyBom',
        name: 'subassemblyBom',
        component: () => import('../views/AssyBOMView.vue'),
      },
      {
        path: 'netCost',
        name: 'netCost',
        component: () => import('../views/NetCost.vue'),
      },
      {
        path: 'agreement',
        name: 'agreement',
        component: () => import('../views/AgreementView.vue'),
      },
      {
        path: 'agreementGroup',
        name: 'agreementGroup',
        component: () => import('../views/AgreementGroupView.vue'),
      },
      {
        path: 'erpInterfaces',
        name: 'erpInterfaces',
        component: () => import('../views/ERPInterfacesView.vue'),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component:  () => import('../views/LoginView.vue'),
    beforeEnter: loginGuard
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component:  () => import('../views/ResetPasswordView.vue'),
  },
]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function loginGuard(to: any, from: any, next: any) {
  const user = authService.user;
  if (to.name === 'login' && user) {
    next(`general`);
  } else {
    next();
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function authGuard(to: any, from: any, next: any) {
  const user = authService.user;
  if (user) {
    next();
  } else {
    next('/login');
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
